import React, { useCallback } from 'react';
import bem from 'utils/bem.js';
import { VideoButton } from '../../components/VideoButton';
import { useRoomContext } from '../../contexts/RoomContext';

const { block } = bem('leave-room-button');

export const LeaveRoomButton = () => {
    const { room } = useRoomContext();

    const handleLeave = useCallback(() => {
        room.leave();
    }, [room]);

    return (
        <VideoButton className={block()} name={'x-circle'} onClick={handleLeave} />
    )
}
